import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PushNotificationService } from '@core/services/push-notification.service';

export interface PushNotificationData {
  instructionUrlAndroid?: string;
  instructionUrlIOS?: string;
}

@Component({
  selector: 'app-push-notification-modal',
  templateUrl: './push-notification-modal.component.html',
  styleUrls: ['./push-notification-modal.component.scss']
})
export class PushNotificationModalComponent implements OnInit, OnDestroy {
  instructionUrlAndroid: string;
  instructionUrlIOS: string;

  constructor(
    public dialogRef: MatDialogRef<PushNotificationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PushNotificationData,
    private pushNotificationService: PushNotificationService
  ) {
    this.instructionUrlAndroid = (data && data.instructionUrlAndroid) ? data.instructionUrlAndroid : '';
    this.instructionUrlIOS = (data && data.instructionUrlIOS) ? data.instructionUrlIOS : '';
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  openAndroidInstruction(): void {
    if (this.instructionUrlAndroid) {
      window.open(this.instructionUrlAndroid, '_blank');

      this.pushNotificationService.markAsDismissed();
      this.dialogRef.close();
    }
  }

  openIOSInstruction(): void {
    if (this.instructionUrlIOS) {
      window.open(this.instructionUrlIOS, '_blank');

      this.pushNotificationService.markAsDismissed();
      this.dialogRef.close();
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
